import React from "react";

interface Props {
  className?: string;
}

const IconBank: React.FC<Props> = ({ className }) => (
  <svg
    fill="currentColor"
    height="800px"
    width="800px"
    version="1.1"
    id="Capa_1"
    viewBox="0 0 191.36 191.36"
    className={className}
  >
    <path
      d="M152.595,186.486h-35.004c-1.381,0-2.5-1.119-2.5-2.5v-7.607c-5.884,1.236-11.948,1.872-18.031,1.872
	c-8.258,0-16.363-1.14-24.142-3.391v9.126c0,1.381-1.119,2.5-2.5,2.5H38.402c-1.381,0-2.5-1.119-2.5-2.5V151.45
	c-4.254-5.056-7.628-10.619-9.998-16.525H11.676c-0.151,0-0.3-0.014-0.445-0.039c-0.114,0.011-0.228,0.019-0.343,0.024
	c-5.679,0.314-10.442-6.281-10.859-14.919c-0.188-3.887,0.55-7.624,2.077-10.521c1.378-2.615,3.278-4.354,5.466-5.045
	c0.339-0.18,0.716-0.281,1.104-0.281h0.188c0.178-0.021,0.357-0.037,0.538-0.046l0.003,0.057l-0.003-0.057
	c0.418-0.021,0.831-0.004,1.238,0.046h12.149c2.235-13.351,6.865-22.182,16.016-30.6l-3.8-16.198
	c-0.224-0.955,0.131-1.952,0.908-2.551c0.776-0.6,1.832-0.688,2.697-0.229l14.131,7.493c12.392-7.953,27.293-11.982,44.319-11.982
	c39.179,0,71.455,25.677,74.886,58.323c2.027-0.839,4.972-2.387,8.013-5.115c5.419-4.864,6.427-10.451,6.436-10.507
	c0.232-1.361,1.522-2.275,2.885-2.043c1.361,0.232,2.276,1.523,2.043,2.885c-0.051,0.298-1.324,7.372-8.025,13.386
	c-4.394,3.942-8.642,5.808-11.053,6.626c0.001,0.177,0.002,0.355,0.002,0.532c0,14.864-6.083,29.292-17.153,40.74v29.083
	C155.095,185.367,153.975,186.486,152.595,186.486z M133.611,181.486h16.484v-27.605c0-0.662,0.263-1.297,0.73-1.766
	c10.59-10.619,16.423-24.098,16.423-37.952c0-32.581-31.486-59.087-70.188-59.087c-16.543,0-30.903,3.999-42.68,11.886
	l-11.174,9.347c-9.507,8.394-13.791,16.715-15.8,30.69c-0.177,1.23-1.231,2.145-2.475,2.145h-7.484
	c1.608,2.611,2.647,6.051,2.832,9.873c0.203,4.207-0.67,8.054-2.297,10.908h20.082c0.042,0,0.084,0.001,0.127,0.003
	c0.166,0.013,4.662,0.133,7.838-3.439c0.458-0.515,1.107-0.817,1.795-0.838c0.688-0.042,1.354,0.244,1.841,0.731l2.57,2.57
	c0.976,0.977,0.976,2.56,0,3.535c-0.978,0.977-2.56,0.976-3.536,0l-0.863-0.863c-4.253,3.33-9.09,3.325-9.815,3.301h-6.687
	c3.988,8.929,10.534,16.955,19.101,23.375c0.63,0.473,1,1.214,1,2.001v21.186h16.484v-10.023c0-0.804,0.387-1.559,1.039-2.028
	c0.652-0.471,1.492-0.6,2.253-0.343c8.262,2.76,16.958,4.159,25.85,4.159c11.5,0,22.92-2.405,33.024-6.954
	c0.772-0.349,1.67-0.281,2.384,0.18c0.712,0.461,1.143,1.251,1.143,2.1V181.486z M120.091,181.486h8.52v-9.144
	c-2.769,1.09-5.616,2.034-8.52,2.829V181.486z M40.902,181.486h5.532v-19.948c-1.946-1.512-3.792-3.103-5.532-4.766V181.486z
	 M5.377,122.607c0.901,4.432,3.224,7.401,5.27,7.31c0.112-0.006,0.224-0.021,0.336-0.045c0.026-0.007,0.053-0.015,0.08-0.021
	c0.067-0.017,0.134-0.037,0.201-0.06c1.681-0.597,3.279-3.24,3.826-6.88c-1.805-0.086-3.248-1.581-3.248-3.407
	c0-1.745,1.317-3.188,3.009-3.388c-0.389-1.767-1.023-3.371-1.849-4.628c-0.828-1.26-1.776-2.07-2.685-2.318
	c-0.086-0.022-0.171-0.04-0.256-0.052c-0.031-0.005-0.063-0.01-0.093-0.016c-0.094-0.011-0.191-0.012-0.28-0.013
	c-0.063,0.014-0.126,0.024-0.191,0.032c0,0-0.024,0.004-0.024,0.004c-0.072,0.009-0.144,0.016-0.214,0.03
	c-0.04,0.009-0.079,0.017-0.119,0.023c-0.936,0.28-1.866,1.206-2.612,2.622c-0.666,1.262-1.129,2.821-1.36,4.512
	c1.286,0.489,2.203,1.735,2.203,3.19C7.371,120.88,6.553,122.068,5.377,122.607z M15.155,117.918c-0.83,0.052-1.49,0.743-1.49,1.586
	c0,0.876,0.713,1.589,1.589,1.589c0.005,0,0.01,0,0.014,0c0.028-0.595,0.029-1.207-0.001-1.836
	C15.244,118.807,15.207,118.36,15.155,117.918z M5.007,118.311c-0.013,0.476-0.008,0.957,0.016,1.44
	c0.014,0.295,0.035,0.587,0.062,0.874c0.287-0.287,0.464-0.684,0.464-1.121C5.549,119.028,5.339,118.602,5.007,118.311z
	 M41.13,61.561l1.954,8.331l5.338-4.464L41.13,61.561z M50.467,104.065c-4.304,0-7.805-3.501-7.805-7.805s3.501-7.806,7.805-7.806
	s7.805,3.502,7.805,7.806S54.771,104.065,50.467,104.065z M50.467,93.454c-1.547,0-2.805,1.259-2.805,2.806s1.258,2.805,2.805,2.805
	s2.805-1.258,2.805-2.805S52.014,93.454,50.467,93.454z M80.313,93.845L80.313,93.845c-1.381-0.001-2.5-1.12-2.5-2.501
	c0-0.092-0.021-9.358-1.848-17.399c-0.868-3.821-1.659-6.141-2.188-7.444c-2.079,0.555-5.638,1.826-8.328,4.471
	c-2.789,2.743-4.428,6.286-4.444,6.321c-0.574,1.254-2.057,1.807-3.311,1.237c-1.255-0.572-1.811-2.05-1.241-3.306
	c0.081-0.179,2.019-4.403,5.49-7.817c5.233-5.146,12.565-6.194,12.875-6.237c0.906-0.121,1.805,0.257,2.347,0.991
	c0.301,0.407,1.894,2.836,3.675,10.677c1.954,8.601,1.972,18.108,1.972,18.509C82.813,92.727,81.694,93.845,80.313,93.845z
	 M113.407,66.148c-0.332,0-0.669-0.066-0.993-0.207l0,0c-0.058-0.024-5.816-2.467-13.782-2.467c-8.061,0-14.943,2.493-15.012,2.519
	c-1.295,0.477-2.731-0.188-3.209-1.481c-0.477-1.295,0.184-2.73,1.478-3.209c0.312-0.115,7.753-2.828,16.743-2.828
	c9.063,0,15.505,2.764,15.775,2.881c1.266,0.552,1.844,2.025,1.292,3.291C115.29,65.586,114.371,66.148,113.407,66.148z
	 M98.057,40.476c-9.815,0-17.801-7.985-17.801-17.802c0-9.815,7.986-17.801,17.801-17.801s17.801,7.985,17.801,17.801
	C115.859,32.49,107.873,40.476,98.057,40.476z M98.057,9.873c-7.059,0-12.801,5.742-12.801,12.801s5.743,12.802,12.801,12.802
	s12.801-5.743,12.801-12.802S105.116,9.873,98.057,9.873z"
    />
  </svg>
);

export default IconBank;
